import { ArrowRight } from 'lucide-react'

/** Inline step preview shown above pricing on the acquisition landing. */
export function OutreachActivationStepsPreview() {
  return (
    <section className="mb-10 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[15px] tracking-[-0.01em] text-foreground/75">
      <span>Complete your profile</span>
      <ArrowRight className="size-3.5 text-muted-foreground/50" />
      <span>Connect your LinkedIn</span>
      <ArrowRight className="size-3.5 text-muted-foreground/50" />
      <span className="font-semibold text-primary">Book calls</span>
      <ArrowRight className="size-3.5 text-muted-foreground/50" />
      <span className="font-medium text-emerald-400">Pay only for what you get</span>
    </section>
  )
}
